export const getGSTRates = (registrationType: number) => {
  if (registrationType === 2) {
    return [
      { id: -1, rate: 'NIL' },
      { id: 0, rate: '0%' },
      { id: 3, rate: '3%' },
      { id: 5, rate: '5%' },
      { id: 12, rate: '12%' },
      { id: 18, rate: '18%' },
      { id: 28, rate: '28%' },
      { id: 40, rate: '40%' },
    ];
  }
  
  return [
    { id: 0, rate: '0%' },
    { id: 3, rate: '3%' },
    { id: 5, rate: '5%' },
    { id: 12, rate: '12%' },
    { id: 18, rate: '18%' },
    { id: 28, rate: '28%' },
  ];
};

export const AccountTypes = [
  { label: 'Current Account', value: '1' },
  { label: 'Savings Account', value: '2' },
  { label: 'Overdraft', value: '3' },
];

export type InitialStateType = {
  ledgerName: string;
  selectedGroup: null | number | undefined;
  hsnId: string;
  gstRate: null | number;
  cessType: string;
  cessValue: number | null;
  taxability: number | null;
  ifscCode: string;
  bankName: string;
  branch: string;
  accountNumber: string;
  swiftCode: string;
  accountType: string;
  isEdit: boolean;
  ledgerNameOrigin: string;
  isDirty: {
    ledgerName: boolean;
    bankDetails: boolean;
    gstDetails: boolean;
  };
};

export type InitialStateErrorType = {
  ledgerName: string;
  selectedGroup: string;
  hsnId: string;
  gstRate: number;
  cessType: string;
  cessValue: string;
  taxability: string;
  ifscCode: string;
  bankName: string;
  branch: string;
  accountNumber: string;
  swiftCode: string;
  accountType: string;
  isEdit: string;
  isDirty: {
    ledgerName: string;
    bankDetails: string;
    gstDetails: string;
  };
};

export const INITIAL_STATE: InitialStateType = {
  ledgerName: '',
  selectedGroup: null,
  hsnId: '',
  gstRate: null,
  cessType: 'Amount',
  cessValue: null,
  taxability: null,
  ifscCode: '',
  bankName: '',
  branch: '',
  accountNumber: '',
  swiftCode: '',
  accountType: '',
  isEdit: false,
  ledgerNameOrigin: '',
  isDirty: {
    ledgerName: false,
    bankDetails: false,
    gstDetails: false,
  },
};

export const fieldLabels = {
  ledgerName: 'Ledger Name',
  selectedGroup: 'Selected Group',
  ifscCode: 'IFSC Code',
  bankName: 'Bank Name',
  branch: 'Branch',
  accountNumber: 'Account Number',
  accountType: 'Account Type',
  hsnId: 'HSN/SAC Code',
  gstRate: 'GST Rate',
  cessValue: 'Cess Value',
  taxability: 'Taxability',
};

export const map: Record<string, string> = { '/17': 'bank', '/29': 'bank', '/7': 'supplier', '/15': 'customer' };

export const getTaxabilityOptions = (companyType: number) => {
  return companyType === 3
    ? [
        { label: 'Composition - Taxable', value: 1 },
        { label: 'Exempted', value: 2 },
        { label: 'Non-Taxable(Non-GST)', value: 3 },
        { label: 'Out of scope', value: 5 },
      ]
    : [
        { label: 'Taxable', value: 1 },
        { label: 'Exempted', value: 2 },
        { label: 'Non-Taxable(Non-GST)', value: 3 },
        { label: 'GST Reverse Charge', value: 4 },
        { label: 'Out of scope', value: 5 },
      ];
};
